export enum AssigneeType {
    Default = 0,
    Reviewer = 1,
    QA = 2,
}
